import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteACard, loadCardsData, saveACard, updateACard, clearCardErrorMsg} from "../../redux/modules/card";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import InputMask from 'react-input-mask'
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CardCreditCard from "./CardCreditCard";
//import {loadLocationsData} from "../../redux/modules/location";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import CardFaxRecord from "./CardFaxRecord";
import CardExpandableRecord from "./CardExpandableRecord";
import * as MainConstants from "../../utils/MainConstants";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";



const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#e2580d",
        color:"black",
        textTransform: "unset !important",
        width: '80%',
    },
    gridList: {
        width:'100%',
        height:500,
    },
});

function PaperComponent(props) {
    return (
      <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
          <Paper {...props} />
      </Draggable>
    );
}

class CreditCard extends React.Component {
    
    
    state = {
        
        //selectedLocation:{},
        selectedCard:{ "id":"", "country":"U.S.A", "state":"Massachusetts", "month":"-", "year":"-"},
        inputFieldShrinkState:true,
        numberShrink:false , //Jut sfor alter I can add a shrink flag for each filed.
        open:true,
        showCardSavedDialog: false
        
        
    };
    //const [open, setOpen] = React.useState(false);
    
    constructor(props) {
        super(props);
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleFirstnameChange = this.handleFirstnameChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleAddress1Change = this.handleAddress1Change.bind(this);
        this.handleLastnameChange = this.handleLastnameChange.bind(this);
        
        this.handleAddress2Change = this.handleAddress2Change.bind(this);
        
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleSecurityCodeChange = this.handleSecurityCodeChange.bind(this);
        this.getListOfCreditCards = this.getListOfCreditCards.bind(this);
        //this.handleClickOpen = this.handleClickOpen.bind(this);
        //this.handleClose = this.handleClose.bind(this);
        this.handlePhoneChange=this.handlePhoneChange.bind(this);
        this.handleMonthChange = this.handleMonthChange.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);
        
        this.handleClickShowSavedCard = this.handleClickShowSavedCard.bind(this);
        this.handleClickShowSavedCardClose = this.handleClickShowSavedCardClose.bind(this);
        
        
        
        
        
        
        
    }
    
    
    handleClickShowSavedCard() {
        this.setState({ showCardSavedDialog: true });
    };
    
    
    handleClickShowSavedCardClose() {
        let { clearCardErrorMsg } = this.props;
        this.setState({ showCardSavedDialog: false });
        clearCardErrorMsg();
    };
    
    
    handleSubmit () {
        
        
        let { saveACard } = this.props;
        
        var tempStream = this.state.selectedCard ;
        //tempStream.locationId= this.state.selectedLocation.id;
        saveACard(DEFAULT_VESPAAN_SERVER.url,  tempStream);
        
    };
    
    handleUpdate () {
        let { updateACard } = this.props;
        
        var tempStream = this.state.selectedCard ;
        //tempStream.locationId= this.state.selectedLocation.id;
        updateACard(DEFAULT_VESPAAN_SERVER.url,  tempStream);
        
    };
    
    handleZipcodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{zipcode:event.target.value}));
    }
    handleCountryChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{country:event.target.value}));
    }
    
    handleMonthChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{month:event.target.value}));
    }
    
    handleYearChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{year:event.target.value}));
    }
    
    handleStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{state:event.target.value}));
    }
    
    
    handleCityChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{city:event.target.value}));
    }
    
    handleAddress2Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{address2:event.target.value}));
    }
    
    handleAddress1Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{address1:event.target.value}));
    }
    
    handleFirstnameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{firstName:event.target.value}));
    }
    
    
    handleLastnameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{lastName:event.target.value}));
    }
    
    handleNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{name:event.target.value}));
    }
    
    handleSecurityCodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{securityCode:event.target.value}));
    }
    
    handleNumberChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{number:event.target.value}));
        //this.setState({numberShrink:true});
    }
    handlePhoneChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedCard,{phone:event.target.value}));
        //this.setState({numberShrink:true});
    }
    
    
    handleLocationChange(event) {
        //event.preventDefault();
        this.setState({selectedLocation: event.target.value});
        //this.setState({selectedVideoControllerName: event.target.value.displayName});
    }
    
    
    clearFields = (e) => {
        e.preventDefault();
        this.setState(state => ({
            inputFieldShrinkState:true
        }));
        
        
        var tempSelectedCard =   Object.assign({}, this.state.selectedCard);
        Object.keys(tempSelectedCard).map((key, index) => {
            tempSelectedCard[key] = "" ;
        });
        this.setState({selectedCard:tempSelectedCard})
        
        
        
        
    };
    
    getListOfCreditCards() {
        let tempArray = this.props.cardsArray;
        let returnArray=[];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                return(<CardCreditCard info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCreditCard> );
            });
        }
        return(returnArray);
    }
    
    /*
    getListOfFaxes() {
        let tempArray = this.props.cardsArray;
        let returnArray=[];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                return(<CardExpandableRecord info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardExpandableRecord> );
            });
        }
        return(returnArray);
    }  */
    
    
    renderErrorFiled(data){
    
    
    }
    
    refresh(event) {
        let { loadCardsData } = this.props;
        loadCardsData(DEFAULT_VESPAAN_SERVER.url );
    }
    
    
    render() {
        const {classes} = this.props;
        let creditCardList = this.getListOfCreditCards();
        // let faxCardList = this.getListOfFaxes();
        let usStates = MainConstants.getUSStates();
        let canStates = MainConstants.getCanadaStates();
        let availableCountries = MainConstants.getCountries();
        let months = MainConstants.getMonths();
        let years = MainConstants.getYears();
        return (
          <React.Fragment>
              <Typography variant="h6" gutterBottom>
                  Credit Card Information
              </Typography>
              <Grid container spacing={24}>
                  
                  <Grid item xs={12} sm={12}>
                      <Grid container >
                          <Grid item xs={5} sm={5}>
                              <Grid container >
                                  
                                  <Grid item xs={5} sm={5} >
                                      <TextField required id="number" name="number"  label="Number"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedCard.number} onChange={this.handleNumberChange}/>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5} >
                                      <TextField required id="name" name="name"  label="Name on the card"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.name} onChange={this.handleNameChange}/>
                                  </Grid>
                              </Grid>
                              
                              <Grid item xs={12}>
                                  <TextField  required id="address1" name="address1" label="Address line 1"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.address1} onChange={this.handleAddress1Change}  />
                              </Grid>
                              <Grid item xs={12}>
                                  <TextField id="address2" name="address2" label="Address line 2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.address2} onChange={this.handleAddress2Change} />
                              </Grid>
                              <Grid container >
                                  <Grid item xs={5} sm={5} >
                                      <TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.city} onChange={this.handleCityChange}/>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5}>
                                      {/*<TextField  required id="country"  name="country"  label="Country"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.country} onChange={this.handleCountryChange} />
                                                                */}<FormControl className={classes.formControl}>
                                      <InputLabel htmlFor="age-helper">Country</InputLabel>
                                      <Select value={this.state.selectedCard.country}
                                              onChange={ this.handleCountryChange}
                                              inputProps={{
                                                  name: 'country',
                                                  id: 'country-helper',
                                              }}
                                      >
                                          
                                          {availableCountries}
                                      
                                      </Select>
                                  
                                  </FormControl>
                                  
                                  
                                  
                                  
                                  </Grid>
                                  <Grid item xs={5} sm={5}>
                                      <TextField  required  id="zip"  name="zip"  label="Zip / Postal code"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.zipcode} onChange={this.handleZipcodeChange}  />
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5} >
                                      {/*<TextField id="state" name="state" label="State/Province/Region" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.state} onChange={this.handleStateChange}/>
                                                               */}
                                      <FormControl className={classes.formControl}>
                                          <InputLabel htmlFor="age-helper">State</InputLabel>
                                          <Select value={this.state.selectedCard.state}
                                                  onChange={ this.handleStateChange}
                                                  inputProps={{
                                                      name: 'state',
                                                      id: 'state-helper',
                                                  }}
                                          >
                                              
                                              {(this.state.selectedCard.country == "U.S.A") &&  (usStates) }
                                              { (this.state.selectedCard.country != "U.S.A") && (canStates)}
                                          
                                          
                                          </Select>
                                          {/* <FormHelperText>Select a State </FormHelperText> */}
                                      </FormControl>
                                  
                                  </Grid>
                                  
                                  
                                  <Grid item xs={5} sm={5}>
                                      <InputMask mask="(999) 999-9999"  value={this.state.selectedCard.phone} onChange={this.handlePhoneChange} >
                                          {()=> <TextField  required id="phone"  name="phone"  label="Phone"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  />  }
                                      </InputMask>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5}>
                                      <TextField  required id="securityCode" name="securityCode" label="Security Code"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.securityCode} onChange={this.handleSecurityCodeChange}  />
                                  </Grid>
                                  <Grid item xs={2} sm={2}>
                                      {/*<TextField  required id="expiratioMonth" name="expiratioMonth" label="Expiration Month"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.securityCode} onChange={this.handleSecurityCodeChange}  />
                                */}
                                      <FormControl className={classes.formControl}>
                                          <InputLabel htmlFor="age-helper">Expiration Month</InputLabel>
                                          <Select value={this.state.selectedCard.month}
                                                  onChange={ this.handleMonthChange}
                                                  inputProps={{
                                                      name: 'month',
                                                      id: 'month-helper',
                                                  }}
                                          >
                                              
                                              {months}
                                          
                                          </Select>
                                      
                                      </FormControl>
                                  </Grid>
                                  <Grid item xs={1} sm={1} >
                                  </Grid>
                                  <Grid item xs={2} sm={2}>
                                      {/*}
                                      <TextField  required id="expirationYear" name="expirationYear" label="Expiration Year"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedCard.securityCode} onChange={this.handleSecurityCodeChange}  />
                                            */}
                                      <FormControl className={classes.formControl}>
                                          <InputLabel htmlFor="age-helper">Expiration Year</InputLabel>
                                          <Select value={this.state.selectedCard.year}
                                                  onChange={ this.handleYearChange}
                                                  inputProps={{
                                                      name: 'year',
                                                      id: 'year-helper',
                                                  }}
                                          >
                                              
                                              {years}
                                          
                                          </Select>
                                      
                                      </FormControl>
                                  
                                  </Grid>
                                  <Grid item xs={7} sm={7} >
                                  </Grid>
                                  
                                  <Grid item xs={6} sm={6}>
                                      {((this.state.selectedCard.id === undefined) || (this.state.selectedCard.id === "")) && (
                                      <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}  >
                                          Add Credit Card
                                      </Button>)}
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      {(this.state.selectedCard.id !=='')&&(
                                      <Button variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}  >
                                          Update Credit Card
                                      </Button>)}
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                    
                                      <Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
                                          Clear Fields
                                      </Button>
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}  >
                                          Refresh
                                      </Button>
                                  </Grid>
                              
                              </Grid>
                          </Grid>
                          <Grid item xs={1} sm={1} >
                          </Grid>
                          <Grid item xs={6} sm={6}>
                              {/*<DynamicTable  data={this.props.cardsArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable>
                        */}
                              {  (this.props.cardsArray.length > 1) &&
                                (<  Typography
                                  variant = "h6"
                                  gutterBottom >
                                    There
                                    are { this.props.cardsArray.length } credit cards in your
                                    profile.
                                < /Typography>)
                              }
                              
                              {  (this.props.cardsArray.length == 1) &&
                                (<
                                  Typography
                                  variant = "h6"
                                  gutterBottom >
                                    There
                                    is
                                    one
                                    credit
                                    card in your
                                    profile.
                                < /Typography>)
                              }
                              
                              {  (this.props.cardsArray.length == 0) &&
                                (<
                                  Typography
                                  variant = "h6"
                                  gutterBottom >
                                    There
                                    is
                                    no
                                    credit
                                    card in your
                                    profile.
                                < /Typography>)
                              }
                              
                              <GridList cellHeight={100} className={classes.gridList}>
                                  { creditCardList}
                                  {/* { faxCardList}  */}
                              </GridList>
                          </Grid>
                      
                      </Grid>
                      <Grid container >
                          {/*} {  (this.props.errorCMsg) && (this.props.errorCMsg.message) && (
                            <Grid item xs={12}   >
                            <TextField error id="outlined-error" label="Error - Operation Failed" value= {" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " +  this.props.errorCMsg.timestamp}
                                className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                            </Grid>)
                        } */}
                          {/*
                          {  !this.props.errorCMsg && (
                        <Grid item xs={12}   >
                            <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                            className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                        </Grid>)
                        }
                        */}
                      </Grid>
                  </Grid>
                  {/* This is for submit event error/success display */}
                  <Dialog
                    open={this.state.showCardSavedDialog}
                    onClose={this.handleClickShowSavedCardClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">Credit Card Information</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          
                          {(this.props.errorCMsg.status == 200) && (<div>
                              The Operation was SUCCESSFUL!  Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
                          </div>)}
                          {(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
                              The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
                          </div>)}
                      
                      </DialogContent>
                      <DialogActions>
                          {/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
                          
                          <Button onClick={this.handleClickShowSavedCardClose} color="secondary">Close</Button>
                      </DialogActions>
                  </Dialog>
              
              
              
              </Grid>
          </React.Fragment>
        );
    }//end of render
    
    
    
    editRecord(singleRowData){
        this.setState({inputFieldShrinkState:true});
        this.setState({selectedCard:singleRowData });
        //We need to change the seleted Location as well.
        //let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );
        
        //this.setState({selectedLocation:tempLocation });
        
    }
    
    
    deleteRecord(argProcessId){
        //alert('I am deleting ' + argCameraId);
        let { deleteACard } = this.props;
        deleteACard(DEFAULT_VESPAAN_SERVER.url,argProcessId  );
    }
    
    /*handleClickOpen(){
        this.setState({ open: true });
    };

    handleClose(){
        this.setState({ open: false });
    };*/
    
    
    
    componentWillMount(){
        let { loadCardsData , loadLocationsData } = this.props;
        loadCardsData(DEFAULT_VESPAAN_SERVER.url );
        //loadLocationsData("http://localhost:9065/" );
        
        this.setState({
            errorCMsg:{}
        });
        
        
    }
    
    componentWillReceiveProps(nextProps) {
        if (this.props.cardsArray !== nextProps.cardsArray) {
            this.setState({
                cardsArray: nextProps.cardsArray
            });
        }
        if (nextProps.errorCMsg.status != null) {
            if (nextProps.errorCMsg.status != null) {
                this.handleClickShowSavedCard();
            }
        }
        
    }
    
    
    
}//end of class

CreditCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        cardsArray: state.card.cardsArray,
        CardDeleteResponse:state.card.deleteCardResp,
        CardSaveResponse:state.card.saveCardResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg:state.card.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadCardsData:loadCardsData,
        deleteACard:deleteACard,
        saveACard:saveACard,
        updateACard:updateACard,
        clearCardErrorMsg:clearCardErrorMsg,
        
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CreditCard));
